import React, { lazy, Suspense } from 'react';
import { PageReady } from '@bingads-webui/page-ready';

export function withPageReadyAsync(componentLoader, FallbackComponent = null, pageName = '') {
  const pageReadyPromise = PageReady.afterPageReady(pageName);
  const WrappedComponent = lazy(() => pageReadyPromise.then(() => componentLoader()));

  return React.memo(props => ((
    <Suspense fallback={FallbackComponent === null ? null : (<FallbackComponent pageReady={false} {...props} />)}>
      <WrappedComponent pageReady {...props} />
    </Suspense>
  )));
}
